import { isPdmStructureV2Enabled } from "./isPdmStructureV2Enabled"

/**
 * True when both:
 * - `NEXT_PUBLIC_UPHOLSTERY_STEPS_V2=true`
 * - `NEXT_PUBLIC_UPHOLSTERY_PDM_V2_STRUCTURE=true` (PDM V2)
 *
 * Loads Build / Kit / Pattern / Design / Material from the global
 * Dato "Upholstery Steps V2" collection instead of each car's nested steps.
 * Steps V2 only runs inside the PDM V2 path.
 */
export function isUpholsteryStepsV2Enabled(): boolean {
  if (!isPdmStructureV2Enabled()) {
    return false
  }

  return (
    typeof process.env.NEXT_PUBLIC_UPHOLSTERY_STEPS_V2 === "string" &&
    process.env.NEXT_PUBLIC_UPHOLSTERY_STEPS_V2.trim().toLowerCase() === "true"
  )
}
